import { FixedAgreement } from '@/views/employees/profile/tab-components/score/score-utils';
import Agreement from './agreement.entity';

function parseAgreementValue(value: string): number {
  const parsed = parseFloat(value);
  if (Number.isNaN(parsed)) {
    throw new Error(`Invalid agreement numeric value: "${value}"`);
  }
  return parsed;
}

export function isUnlockedDuczSyndicateFree(
  agreementList: Agreement[],
  maxDuczSyndicatePercent: number,
): boolean {
  const targetDescription = FixedAgreement.DUCZ_SYNDICATE_FREE;
  const salaryCLT = agreementList.find(
    a => a.description === FixedAgreement.SALARY_IN_CLT,
  );
  const agreementDucz = agreementList.find(
    a => a.description === targetDescription,
  );
  if (!agreementDucz || !agreementDucz.newAgreement
    || !salaryCLT || !salaryCLT.newAgreement) return false;
  const duczSyndicateMaxValue = parseAgreementValue(salaryCLT.newAgreement)
    * maxDuczSyndicatePercent;
  return parseAgreementValue(agreementDucz.newAgreement) > duczSyndicateMaxValue;
}

export function isUnlockedBenefitLimit(
  agreementList: Agreement[],
  maxBenefitPercent: number,
): boolean {
  const targetDescriptions = [
    FixedAgreement.DUCZ,
    FixedAgreement.DUCZ_SYNDICATE_FREE,
  ];
  const salaryCLT = agreementList.find(
    a => a.description === FixedAgreement.SALARY_IN_CLT,
  );
  if (!salaryCLT || !salaryCLT.newAgreement) return false;
  const totalGroupValue = agreementList
    .filter(a => targetDescriptions.includes(a.description as FixedAgreement) && a.newAgreement)
    .reduce((sum, a) => sum + parseAgreementValue(a.newAgreement), 0);
  const salaryCLTValue = parseAgreementValue(salaryCLT.newAgreement);
  const maxAllowed = salaryCLTValue * maxBenefitPercent;
  return totalGroupValue > maxAllowed;
}

export function isUnlockedDuczFreeMinimum(
  agreementList: Agreement[],
  minDuczFreeMinimumValue: number,
): boolean {
  const targetDescription = FixedAgreement.DUCZ_SYNDICATE_FREE;
  const agreementDucz = agreementList.find(
    a => a.description === targetDescription,
  );
  if (!agreementDucz || !agreementDucz.newAgreement) return false;
  return parseAgreementValue(agreementDucz.newAgreement) < minDuczFreeMinimumValue;
}

export function isUnlockedDuczFoodMaximum(
  agreementList: Agreement[],
  maxDuczFoodValue: number,
): boolean {
  if (!maxDuczFoodValue || maxDuczFoodValue <= 0) return false;
  const targetDescription = FixedAgreement.DUCZ;
  const agreementDucz = agreementList.find(
    a => a.description === targetDescription,
  );
  if (!agreementDucz || !agreementDucz.newAgreement) return false;
  return parseAgreementValue(agreementDucz.newAgreement) > maxDuczFoodValue;
}

export function isUnlockedTotalLimit(
  agreementList: Agreement[],
  maxTotalLimit: number,
): boolean {
  const totalAgreement = agreementList.find(
    a => a.description === FixedAgreement.TOTAL,
  );
  if (!totalAgreement || !totalAgreement.newAgreement
    || !totalAgreement.previousAgreement) return false;
  const previousValue = parseAgreementValue(totalAgreement.previousAgreement);
  const newValue = parseAgreementValue(totalAgreement.newAgreement);
  const maxAllowed = previousValue * maxTotalLimit;
  return newValue > maxAllowed;
}
